/* Onyx: cart notes for staff reports. Key in the staff documentation, not here. */
(() => {
  if (window.onyxT) return;
  window.onyxT = true;

  const KEY = '_ot';
  const DAYS = 7;
  const SOURCES = { 'onyx-colour-chart': '1', 'onyx-inspo': '2', 'onyx-quiz': '3' };

  const root = () => {
    const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return base.endsWith('/') ? base : `${base}/`;
  };

  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || {};
    } catch (error) {
      return {};
    }
  };

  const mark = (code) => {
    try {
      const marks = read();
      marks[code] = Date.now();
      localStorage.setItem(KEY, JSON.stringify(marks));
    } catch (error) {
      /* storage unavailable */
    }
  };

  const recent = () => {
    const marks = read();
    const since = Date.now() - DAYS * 24 * 60 * 60 * 1000;
    return Object.keys(marks)
      .filter((code) => /^[123]$/.test(code) && marks[code] > since)
      .sort()
      .join(', ');
  };

  const label = (line) => {
    const title = String(line.product_title || line.title || '').trim();
    const number = title.split(/\s+/).find((word) => /^\d/.test(word));
    return number || title;
  };

  let queue = Promise.resolve();

  const note = (code, lines) => {
    queue = queue
      .then(async () => {
        const response = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        if (!cart.item_count) return;
        const current = cart.attributes || {};
        const attributes = {};

        if (code && lines.length) {
          const key = `_t${code}`;
          const list = String(current[key] || '')
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean);
          lines.map(label).forEach((value) => {
            if (value && !list.includes(value)) list.push(value);
          });
          const value = list.join(', ');
          if (value !== (current[key] || '')) attributes[key] = value;
        }

        const used = recent();
        if (used && used !== (current._t0 || '')) attributes._t0 = used;

        if (!Object.keys(attributes).length) return;
        await fetch(`${root()}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes }),
        });
      })
      .catch(() => {});
  };

  if (document.querySelector('onyx-colour-chart')) mark('1');
  if (document.querySelector('onyx-inspo')) mark('2');
  document.addEventListener('onyx:quiz-result', () => mark('3'));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
      const code = data && SOURCES[data.source];
      const cart = data && data.cart;
      if (code && cart && Array.isArray(cart.items) && cart.item_count === undefined) {
        note(code, cart.items);
      } else if (recent()) {
        note(null, []);
      }
    });
  }

  document.addEventListener('ajaxProduct:added', (event) => {
    const detail = event.detail || {};
    if (detail.source === 'onyx-quiz') {
      mark('3');
      note('3', (detail.product && detail.product.items) || []);
    } else if (recent()) {
      note(null, []);
    }
  });

  if (recent()) note(null, []);
})();
